import CalendarActivities from './CalendarActivities';

export default CalendarActivities;
